// Адресов стендов в документации нет: вкладка показывает текущую установку
// и переходит по ссылке, только когда адрес появится в этом списке.
export const stands = [
  { id: 'prod', label: 'ПРОД', href: null, dot: 'dot-prod' },
  { id: 'dev1', label: 'ДЕВ 1', href: null, dot: 'dot-dev1' },
  { id: 'dev2', label: 'ДЕВ 2', href: null, dot: 'dot-dev2' },
];

export const currentStandId = 'dev1';

const standKey = 'rhm-panel-stand';

export function readStandId() {
  try {
    const stored = sessionStorage.getItem(standKey);
    if (stands.some((item) => item.id === stored)) {
      return stored;
    }
  } catch {
    // sessionStorage недоступен
  }
  return currentStandId;
}

export function rememberStand(id) {
  try {
    sessionStorage.setItem(standKey, id);
  } catch {
    // sessionStorage недоступен
  }
}
